import { render, staticRenderFns } from "./release-summary.vue?vue&type=template&id=10cb9134&"
import script from "./release-summary.vue?vue&type=script&lang=js&"
export * from "./release-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports